import { PartialType, PickType } from '@nestjs/swagger';
import { RegionAuditUpdatableInterface } from '../interfaces/region-audit-updatable.interface';
import { RegionAuditDto } from './region-audit.dto';

export class RegionAuditUpdateDto
  extends PartialType(
    PickType(RegionAuditDto, [
      'actionType',
      'changedByUserId',
      'changeReason',
      'name',
      'archived',
      'repairsRate',
      'specialJobsPercentage',
      'pieceworkPercentage',
      'allowPayoutAmountEditing',
      'interiorOptionsPercentage',
      'exteriorOptionsPercentage',
      'trimOptionPercentage',
      'phaseStructureType',
      'garageCostFixed',
      'dwHangingCostPerBoard',
      'dwFinishingCostPerBoard',
      'dwSprayingCostPerBoard',
      'highCeilingPerBoard',
      'screwInspectionPerBoard',
      'dwpHangingCostPerBoard',
      'dwpFinishCostPerBoard',
      'dwpPrimeCostPerSqft',
      'dwpBump1CostPerBoard',
      'dwpTrim1CostPerSqft',
      'dwpInteriorPaintCostPerSqft',
      'dwpBump2CostPerBoard',
      'dwpTrim2CostPerSqft',
      'dwpFinalPaintCostPerSqft',
      'dwpBump3CostPerBoard',
      'dwpCMBluetapeCostPerSqft',
      'dwpFinalBluetapeCostPerSqft',
    ] as const),
  )
  implements RegionAuditUpdatableInterface {}
